import React, { useEffect } from 'react'

function Items(props) { //song object, onClick function

    const filter = (elem) => {
        switch (elem.nodeName.toUpperCase()) {
            case 'DIV':
                return true;
            default:
                return false;
        }
    }
    const setCustomClass = () => {
        let elem = document.getElementById(props.song.id)
        let sibs = [];
        elem = elem.parentNode.firstChild;
        do {
            if (elem.nodeType === 3) continue; // text node
            if (!filter || filter(elem)) sibs.push(elem);
        } while (elem = elem.nextSibling)

        if (sibs.length === 1) {
            return document.getElementById(props.song.id).classList.add("p-2", "w-full")
        }
        if (sibs.length === 2) {
            return document.getElementById(props.song.id).classList.add("p-2", "md:w-1/2", "w-full")
        }
        else {
            return document.getElementById(props.song.id).classList.add("p-2", "lg:w-1/3", "md:w-1/2", "w-full")
        }
    }

    useEffect(() => {
        setCustomClass();

    }, [])
    return (

        <div id={props.song.id}>
            {/* onClick: sends song details to Search.js and navigates to /listen */}
            <div
                onClick={props.onClick}
                className="relative h-full flex items-center border border-cyan-500/40 p-4 rounded-2xl hover:cursor-pointer hover:border-cyan-400 hover:ring-2 hover:ring-cyan-400/60 bg-black/60 backdrop-blur-md transition-colors duration-200"
            >
                <img
                    alt="thumbnail"
                    className="w-20 h-20 bg-black object-cover object-center flex-shrink-0 rounded-2xl mr-4"
                    src={props.song.image[2].link}
                />
                <div className="flex-grow min-w-0">
                    <h2 className="text-white title-font font-medium truncate">
                        {props.song.name ? props.song.name.replace(/&quot;/g, '"') : props.song.title.replace(/&quot;/g, '"')}
                    </h2>
                    <p className="text-sm text-gray-300 truncate">
                        {props.song.primaryArtists ? props.song.primaryArtists : props.song.artist}
                    </p>
                </div>

                {props.song.type && (
                    <span className="absolute right-0 top-2 inline-flex items-center justify-center px-2 py-1 mr-2 text-xs font-bold leading-none bg-cyan-500 text-black rounded-full">
                        {props.song.type.toUpperCase()}
                    </span>
                )}
            </div>
        </div>
    )
}

export default Items
